import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import CampaignDetailsTable from '../../components/CampaignDetailsTable';
import PropTypeCampaign from '../../utilities/propTypes/PropTypeCampaign';
import { CampaignStatuses } from '../../constants';

const DownloadCodes = ({ campaign, onDownloadClick, onRecreateClick }) => (
  <div className="campaign-download-codes">
    <h1>Distribute Codes</h1>
    <p>
      Thank you for creating a campaign with Tabby Rewards. To get started, you must download your
      campaign&apos;s redemption codes. This is the only time they will be available.
    </p>
    {campaign.status.is(CampaignStatuses.confirmingSend) && (
      <p className="pending">
        Your transaction is currently pending. The time it takes for your transaction to finalize
        will depend on network congestion. Please be patient while your transaction is processed.
      </p>
    )}
    {campaign.status.is(CampaignStatuses.failed) && (
      <React.Fragment>
        <p className="error">
          Unfortunately, your campaign was not created, as the transaction failed. This could have
          been due to one of the following reasons: failed payment or manually reduced gas limit.
          You will have to re-create your campaign and download new codes.
        </p>
        <div className="actions">
          <button type="button" className="btn cancel" name="download" onClick={onRecreateClick}>
            Re-Create Campaign
          </button>
        </div>
      </React.Fragment>
    )}
    {campaign.status.is(CampaignStatuses.active) && (
      <p className="success">
        Your campaign was created successfully. All your reward codes are now active!
      </p>
    )}
    {!campaign.status.is(CampaignStatuses.failed) && (
      <React.Fragment>
        <CampaignDetailsTable {...campaign} />
        <div className="actions">
          <button type="button" className="btn" name="download" onClick={onDownloadClick}>
            Download Codes
          </button>
          <NavLink className="btn secondary" to={`/manage-campaigns/${campaign.transactionHash}`}>
            Manage Campaign
          </NavLink>
        </div>
      </React.Fragment>
    )}
  </div>
);

DownloadCodes.displayName = 'DownloadCodes';

DownloadCodes.propTypes = {
  onDownloadClick: PropTypes.func.isRequired,
  campaign: PropTypes.shape(PropTypeCampaign).isRequired,
  onRecreateClick: PropTypes.func.isRequired,
};

export default DownloadCodes;



// WEBPACK FOOTER //
// ./src/containers/createCampaign/DownloadCodes.js